import { useState } from "react"

import { AiComponentsTabTemplate } from "./AiComponentsTabTemplate"
import { AiComponentsTabs, HierarchyGraph } from "./lazyComponents"
import { COMPONENT_TABS, DEFAULT_COMPONENT_TAB } from "./tabOptions"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"
import type { AiComponentsEntityType } from "./AiComponentsTabAgentAiDiscoveryDrawer.types"

// A workflow's tab, and an agent's as before MCP servers: demo/mock mode renders only this
export const AiComponentsTab = (
  props: TabComponentProps & { entityType: AiComponentsEntityType }
) => {
  const { entityType, ...tabProps } = props
  const [tab, setTab] = useState(DEFAULT_COMPONENT_TAB[entityType])

  return (
    <AiComponentsTabTemplate
      tabProps={tabProps}
      entityType={entityType}
      tab={tab}
      options={COMPONENT_TABS[entityType]}
      onTabChange={setTab}
      renderGraph={(recordId) => (
        <HierarchyGraph recordId={recordId} entityType={entityType} />
      )}
    >
      <AiComponentsTabs
        recordId={tabProps.record?.id}
        tab={tab}
        entityType={entityType}
      />
    </AiComponentsTabTemplate>
  )
}
